// extracted by css-extract-rspack-plugin
export default {"emptyState":"Participants-module__emptyState__YGYUG","participants":"Participants-module__participants__EFrTA","hiddenCount":"Participants-module__hiddenCount__QK8Z9"};